import {
  LayoutDashboard, Users, CreditCard, TrendingUp, Activity, FileBarChart,
  Sparkles, Settings, FileText, Link2, Image, Calendar, MessageSquareText,
  CheckCircle2, Send, QrCode, Megaphone, UsersRound, Bell, DatabaseBackup,
  Target, UserCheck, ClipboardCheck,
} from "lucide-react";

export const ADMIN_MENU = [
  { label: "Dashboard", to: "/admin", icon: LayoutDashboard, end: true },
  { label: "Prospect Audit", to: "/admin/prospect-audit", icon: ClipboardCheck },
  { label: "Clients", to: "/admin/clients", icon: Users },
  { label: "Plans", to: "/admin/plans", icon: FileText },
  { label: "Revenue", to: "/admin/revenue", icon: TrendingUp },
  { label: "Usage", to: "/admin/usage", icon: Activity },
  { label: "Reports", to: "/admin/reports", icon: FileBarChart },
  { label: "Automation Logs", to: "/admin/logs", icon: Activity },
  { label: "AI Prompts", to: "/admin/ai-prompts", icon: Sparkles },
  { label: "Settings", to: "/admin/settings", icon: Settings },
  { label: "Backup & Restore", to: "/admin/backup", icon: DatabaseBackup },
];

export const CLIENT_MENU = [
  { label: "Dashboard", to: "/app", icon: LayoutDashboard, end: true },
  { label: "Google Connection", to: "/app/google", icon: Link2 },
  { label: "Profile SEO", to: "/app/seo", icon: Sparkles },
  { label: "Posts", to: "/app/posts", icon: FileText },
  { label: "AI Post Generator", to: "/app/ai-post", icon: Image },
  { label: "Calendar", to: "/app/calendar", icon: Calendar },
  { label: "Reviews", to: "/app/reviews", icon: MessageSquareText },
  { label: "AI Replies", to: "/app/ai-replies", icon: CheckCircle2 },
  { label: "Review Requests", to: "/app/review-requests", icon: Send },
  { label: "QR Code", to: "/app/qr", icon: QrCode },
  { label: "Reports", to: "/app/reports", icon: FileBarChart },
  { label: "Billing", to: "/app/billing", icon: CreditCard },
  { label: "Settings", to: "/app/settings", icon: Settings },
  { label: "Backup & Restore", to: "/app/backup", icon: DatabaseBackup },
];
